// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__3f2WC","editor":"TextArea_editor__u70to"};